import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `jenkins`,

  name: {
    [LOCALES.EN_US]: `Jenkins`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.tool, TYPES.service],

  tags: [],
} as const satisfies TTerm
